
export default {
  name: 'ModalComponent',
  props: {
    modalOpen: Boolean,
    title: {
      type: String,
      default: '',
    },
    primaryButtonText: {
      type: String,
      default: '',
    },
    secondaryButtonText: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 700,
    },
    customClass: {
      type: String,
      default: 'dialog',
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    customMethod() {
      this.$emit('customMethod');
    },
    secondaryCustomMethod() {
      this.$emit('secondaryCustomMethod');
    },
  },
};
